import { JsonProperty, JsonObject, Any } from 'json2typescript';
import { ModelObject } from '@hermes/api-model-core';
import { ErrorItem, Basket } from '@hermes/api-model-basket';
import { Address } from '@hermes/api-model-address';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

let AddAddressResponse = class AddAddressResponse extends ModelObject {
    constructor() {
        super(...arguments);
        this.addressId = undefined;
        this.error = undefined;
    }
};
__decorate([
    JsonProperty("address_id", String, false),
    __metadata("design:type", String)
], AddAddressResponse.prototype, "addressId", undefined);
__decorate([
    JsonProperty("error", ErrorItem, true),
    __metadata("design:type", ErrorItem)
], AddAddressResponse.prototype, "error", undefined);
AddAddressResponse = __decorate([
    JsonObject("AddAddressResponse")
], AddAddressResponse);

let AddressRequest = class AddressRequest {
    constructor() {
        this.address = undefined;
        this.addressType = undefined;
        this.source = undefined;
        this.isKnownButNotConnected = undefined;
    }
};
__decorate([
    JsonProperty("address", Address),
    __metadata("design:type", Address)
], AddressRequest.prototype, "address", undefined);
__decorate([
    JsonProperty("address_type", String),
    __metadata("design:type", String)
], AddressRequest.prototype, "addressType", undefined);
__decorate([
    JsonProperty("source", String),
    __metadata("design:type", String)
], AddressRequest.prototype, "source", undefined);
__decorate([
    JsonProperty("is_known_but_not_connected", Boolean, true),
    __metadata("design:type", Boolean)
], AddressRequest.prototype, "isKnownButNotConnected", undefined);
AddressRequest = __decorate([
    JsonObject("AddressRequest")
], AddressRequest);
const ADDRESS_SOURCE_TYPE_ENUM = {
    CHECKOUT: "checkout",
    ACCOUNT: "account",
};

let NewsletterSubscribeRequest = class NewsletterSubscribeRequest extends ModelObject {
    constructor() {
        super(...arguments);
        this.email = undefined;
        this.password_confirm = undefined;
    }
};
__decorate([
    JsonProperty("email", String, false),
    __metadata("design:type", String)
], NewsletterSubscribeRequest.prototype, "email", undefined);
__decorate([
    JsonProperty("password_confirm", String, true),
    __metadata("design:type", String)
], NewsletterSubscribeRequest.prototype, "password_confirm", undefined);
NewsletterSubscribeRequest = __decorate([
    JsonObject("NewsletterSubscribeRequest")
], NewsletterSubscribeRequest);

let Region = class Region {
    constructor() {
        this.code = undefined;
        this.name = undefined;
    }
};
__decorate([
    JsonProperty("code", String, true),
    __metadata("design:type", String)
], Region.prototype, "code", undefined);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], Region.prototype, "name", undefined);
Region = __decorate([
    JsonObject("Region")
], Region);

let AddressesFields = class AddressesFields {
    constructor() {
        this.neighborhoods = undefined;
        this.region = undefined;
        this.district = undefined;
        this.city = undefined;
    }
};
__decorate([
    JsonProperty("neighborhoods", true),
    __metadata("design:type", Object)
], AddressesFields.prototype, "neighborhoods", undefined);
__decorate([
    JsonProperty("region", Region, true),
    __metadata("design:type", Region)
], AddressesFields.prototype, "region", undefined);
__decorate([
    JsonProperty("district", String, true),
    __metadata("design:type", String)
], AddressesFields.prototype, "district", undefined);
__decorate([
    JsonProperty("city", String, true),
    __metadata("design:type", String)
], AddressesFields.prototype, "city", undefined);
AddressesFields = __decorate([
    JsonObject("AddressesFields")
], AddressesFields);

let RetrieveAddressesResponse = class RetrieveAddressesResponse {
    constructor() {
        this.addresses = undefined;
    }
};
__decorate([
    JsonProperty("addresses", AddressesFields, true),
    __metadata("design:type", AddressesFields)
], RetrieveAddressesResponse.prototype, "addresses", undefined);
RetrieveAddressesResponse = __decorate([
    JsonObject("RetrieveAddressesResponse")
], RetrieveAddressesResponse);

let DateOfBirth = class DateOfBirth {
    constructor() {
        this.day = undefined;
        this.month = undefined;
        this.year = undefined;
    }
};
__decorate([
    JsonProperty("day", Number, true),
    __metadata("design:type", Number)
], DateOfBirth.prototype, "day", undefined);
__decorate([
    JsonProperty("month", Number, true),
    __metadata("design:type", Number)
], DateOfBirth.prototype, "month", undefined);
__decorate([
    JsonProperty("year", Number, true),
    __metadata("design:type", Number)
], DateOfBirth.prototype, "year", undefined);
DateOfBirth = __decorate([
    JsonObject("DateOfBirth")
], DateOfBirth);

/**
 * This class defines the users attributes.
 * @dynamic
 */
let User = class User extends ModelObject {
    constructor(source) {
        super();
        this.basket = undefined;
        this.city = undefined;
        this.cityselect = undefined;
        this.company = undefined;
        this.confirmation = undefined;
        this.countryId = undefined;
        this.customerId = undefined;
        this.district = undefined;
        this.dateOfBirth = undefined;
        this.email = undefined;
        this.favoriteShopCode = undefined;
        this.firstname = undefined;
        this.firstname2 = undefined;
        this.gender = undefined;
        this.gigyaUid = undefined;
        this.lastname = undefined;
        this.lastname2 = undefined;
        this.liftId = undefined;
        this.phoneCode = undefined;
        this.phoneLogin = undefined;
        this.phoneNumber = undefined;
        this.postcode = undefined;
        this.postcodeBis = undefined;
        this.prefix = undefined;
        this.region = undefined;
        this.street1 = undefined;
        this.street2 = undefined;
        this.street3 = undefined;
        this.telephone = undefined;
        this.telephone2 = undefined;
        this.userType = undefined;
        this.shippingAddresses = undefined;
        this.wechatLinked = undefined;
        this.socialSecurityNumber = undefined;
        Object.assign(this, source);
    }
    /**
     * Get the user type for analytics purpose.
     * @param userType type of user.
     */
    getUserType() {
        switch (this.userType) {
            case "0": {
                return "newclient";
            }
            case "1": {
                return "buyer";
            }
            default: {
                return "non-connected";
            }
        }
    }
};
__decorate([
    JsonProperty("basket", Basket, true),
    __metadata("design:type", Basket)
], User.prototype, "basket", undefined);
__decorate([
    JsonProperty("city", String, true),
    __metadata("design:type", String)
], User.prototype, "city", undefined);
__decorate([
    JsonProperty("cityselect", String, true),
    __metadata("design:type", String)
], User.prototype, "cityselect", undefined);
__decorate([
    JsonProperty("company", String, true),
    __metadata("design:type", String)
], User.prototype, "company", undefined);
__decorate([
    JsonProperty("confirmation", String, true),
    __metadata("design:type", String)
], User.prototype, "confirmation", undefined);
__decorate([
    JsonProperty("country_id", String, true),
    __metadata("design:type", String)
], User.prototype, "countryId", undefined);
__decorate([
    JsonProperty("customer_id", String, true),
    __metadata("design:type", String)
], User.prototype, "customerId", undefined);
__decorate([
    JsonProperty("district", String, true),
    __metadata("design:type", String)
], User.prototype, "district", undefined);
__decorate([
    JsonProperty("dob", DateOfBirth, true),
    __metadata("design:type", DateOfBirth)
], User.prototype, "dateOfBirth", undefined);
__decorate([
    JsonProperty("email", String, true),
    __metadata("design:type", String)
], User.prototype, "email", undefined);
__decorate([
    JsonProperty("favorite_shop_code", String, true),
    __metadata("design:type", String)
], User.prototype, "favoriteShopCode", undefined);
__decorate([
    JsonProperty("firstname", String, true),
    __metadata("design:type", String)
], User.prototype, "firstname", undefined);
__decorate([
    JsonProperty("firstname2", String, true),
    __metadata("design:type", String)
], User.prototype, "firstname2", undefined);
__decorate([
    JsonProperty("gender", String, true),
    __metadata("design:type", String)
], User.prototype, "gender", undefined);
__decorate([
    JsonProperty("gigya_uid", String, true),
    __metadata("design:type", String)
], User.prototype, "gigyaUid", undefined);
__decorate([
    JsonProperty("lastname", String, true),
    __metadata("design:type", String)
], User.prototype, "lastname", undefined);
__decorate([
    JsonProperty("lastname2", String, true),
    __metadata("design:type", String)
], User.prototype, "lastname2", undefined);
__decorate([
    JsonProperty("lift_id", String, true),
    __metadata("design:type", String)
], User.prototype, "liftId", undefined);
__decorate([
    JsonProperty("phone_code", String, true),
    __metadata("design:type", String)
], User.prototype, "phoneCode", undefined);
__decorate([
    JsonProperty("phone_login", String, true),
    __metadata("design:type", String)
], User.prototype, "phoneLogin", undefined);
__decorate([
    JsonProperty("phone_number", String, true),
    __metadata("design:type", String)
], User.prototype, "phoneNumber", undefined);
__decorate([
    JsonProperty("postcode", String, true),
    __metadata("design:type", String)
], User.prototype, "postcode", undefined);
__decorate([
    JsonProperty("postcode_bis", String, true),
    __metadata("design:type", String)
], User.prototype, "postcodeBis", undefined);
__decorate([
    JsonProperty("prefix", String, true),
    __metadata("design:type", String)
], User.prototype, "prefix", undefined);
__decorate([
    JsonProperty("region", String, true),
    __metadata("design:type", String)
], User.prototype, "region", undefined);
__decorate([
    JsonProperty("street1", String, true),
    __metadata("design:type", String)
], User.prototype, "street1", undefined);
__decorate([
    JsonProperty("street2", String, true),
    __metadata("design:type", String)
], User.prototype, "street2", undefined);
__decorate([
    JsonProperty("street3", String, true),
    __metadata("design:type", String)
], User.prototype, "street3", undefined);
__decorate([
    JsonProperty("telephone", String, true),
    __metadata("design:type", String)
], User.prototype, "telephone", undefined);
__decorate([
    JsonProperty("telephone2", String, true),
    __metadata("design:type", String)
], User.prototype, "telephone2", undefined);
__decorate([
    JsonProperty("user_type", String, true),
    __metadata("design:type", String)
], User.prototype, "userType", undefined);
__decorate([
    JsonProperty("shipping_addresses", [Any], true),
    __metadata("design:type", Array)
], User.prototype, "shippingAddresses", undefined);
__decorate([
    JsonProperty("wechatlinked", Boolean, true),
    __metadata("design:type", Boolean)
], User.prototype, "wechatLinked", undefined);
__decorate([
    JsonProperty("social_security_number", String, true),
    __metadata("design:type", String)
], User.prototype, "socialSecurityNumber", undefined);
User = __decorate([
    JsonObject("User"),
    __metadata("design:paramtypes", [Object])
], User);

/**
 * This class contains guest informations
 */
let Guest = class Guest {
    constructor() {
        this.areaCode = undefined;
        this.communicationConsent = undefined;
        this.dob = undefined;
        this.email = undefined;
        this.newsletter = undefined;
        this.phoneCode = undefined;
        this.phoneLogin = undefined;
        this.pipl = undefined;
        this.socialSecurityNumber = undefined;
        this.verificationCode = undefined;
    }
};
__decorate([
    JsonProperty("area_code", String, true),
    __metadata("design:type", String)
], Guest.prototype, "areaCode", undefined);
__decorate([
    JsonProperty("communicationConsent", Boolean, true),
    __metadata("design:type", Boolean)
], Guest.prototype, "communicationConsent", undefined);
__decorate([
    JsonProperty("dob", DateOfBirth, true),
    __metadata("design:type", DateOfBirth)
], Guest.prototype, "dob", undefined);
__decorate([
    JsonProperty("email", String, true),
    __metadata("design:type", String)
], Guest.prototype, "email", undefined);
__decorate([
    JsonProperty("newsletter", Boolean, true),
    __metadata("design:type", Boolean)
], Guest.prototype, "newsletter", undefined);
__decorate([
    JsonProperty("phone_code", String, true),
    __metadata("design:type", String)
], Guest.prototype, "phoneCode", undefined);
__decorate([
    JsonProperty("phone_login", String, true),
    __metadata("design:type", String)
], Guest.prototype, "phoneLogin", undefined);
__decorate([
    JsonProperty("pipl", Boolean, true),
    __metadata("design:type", Boolean)
], Guest.prototype, "pipl", undefined);
__decorate([
    JsonProperty("social_security_number", String, true),
    __metadata("design:type", String)
], Guest.prototype, "socialSecurityNumber", undefined);
__decorate([
    JsonProperty("verification_code", String, true),
    __metadata("design:type", String)
], Guest.prototype, "verificationCode", undefined);
Guest = __decorate([
    JsonObject("Guest")
], Guest);

let CustomerAddressRequest = class CustomerAddressRequest extends Address {
    constructor() {
        super(...arguments);
        this.selectedCity = undefined;
        this.locale = undefined;
    }
};
__decorate([
    JsonProperty("cityselect", String, true),
    __metadata("design:type", String)
], CustomerAddressRequest.prototype, "selectedCity", undefined);
__decorate([
    JsonProperty("locale", String, true),
    __metadata("design:type", String)
], CustomerAddressRequest.prototype, "locale", undefined);
CustomerAddressRequest = __decorate([
    JsonObject("CustomerAddressRequest")
], CustomerAddressRequest);

let CustomerAddressResponse = class CustomerAddressResponse {
    constructor() {
        this.basket = undefined;
        this.shippingAddresses = undefined;
        this.error = undefined;
    }
};
__decorate([
    JsonProperty("basket", Basket, true),
    __metadata("design:type", Basket)
], CustomerAddressResponse.prototype, "basket", undefined);
__decorate([
    JsonProperty("shipping_addresses", [Address], true),
    __metadata("design:type", Array)
], CustomerAddressResponse.prototype, "shippingAddresses", undefined);
__decorate([
    JsonProperty("error", ErrorItem, true),
    __metadata("design:type", ErrorItem)
], CustomerAddressResponse.prototype, "error", undefined);
CustomerAddressResponse = __decorate([
    JsonObject("CustomerAddressResponse")
], CustomerAddressResponse);

let CustomerEditAddressResponse = class CustomerEditAddressResponse {
    constructor() {
        this.basket = undefined;
        this.shippingAddresses = undefined;
        this.error = undefined;
    }
};
__decorate([
    JsonProperty("basket", Basket, true),
    __metadata("design:type", Basket)
], CustomerEditAddressResponse.prototype, "basket", undefined);
__decorate([
    JsonProperty("addresses", [Address], true),
    __metadata("design:type", Array)
], CustomerEditAddressResponse.prototype, "shippingAddresses", undefined);
__decorate([
    JsonProperty("error", ErrorItem, true),
    __metadata("design:type", ErrorItem)
], CustomerEditAddressResponse.prototype, "error", undefined);
CustomerEditAddressResponse = __decorate([
    JsonObject("CustomerEditAddressResponse")
], CustomerEditAddressResponse);

let ForgotPasswordRequest = class ForgotPasswordRequest {
    constructor() {
        this.country = undefined;
        this.locale = undefined;
        this.email = undefined;
        this.phoneCode = undefined;
        this.phoneNumber = undefined;
    }
};
__decorate([
    JsonProperty("country", Any, true),
    __metadata("design:type", Object)
], ForgotPasswordRequest.prototype, "country", undefined);
__decorate([
    JsonProperty("locale", Any, true),
    __metadata("design:type", Object)
], ForgotPasswordRequest.prototype, "locale", undefined);
__decorate([
    JsonProperty("email", String, true),
    __metadata("design:type", String)
], ForgotPasswordRequest.prototype, "email", undefined);
__decorate([
    JsonProperty("phonecode", String, true),
    __metadata("design:type", String)
], ForgotPasswordRequest.prototype, "phoneCode", undefined);
__decorate([
    JsonProperty("phonenumber", String, true),
    __metadata("design:type", String)
], ForgotPasswordRequest.prototype, "phoneNumber", undefined);
ForgotPasswordRequest = __decorate([
    JsonObject("ForgotPasswordRequest")
], ForgotPasswordRequest);

let ForgotPasswordResponse = class ForgotPasswordResponse {
    constructor() {
        this.error = undefined;
    }
};
__decorate([
    JsonProperty("error", ErrorItem, true),
    __metadata("design:type", ErrorItem)
], ForgotPasswordResponse.prototype, "error", undefined);
ForgotPasswordResponse = __decorate([
    JsonObject("ForgotPasswordResponse")
], ForgotPasswordResponse);

/**
 * Class Address used for account creation
 */
let AddressAccountCreation = class AddressAccountCreation extends ModelObject {
    constructor() {
        super(...arguments);
        this.countryId = undefined;
        this.street1 = undefined;
        this.addressVerification = undefined;
        this.city = undefined;
        this.cityBisId = undefined;
        this.company = undefined;
        this.district = undefined;
        this.districtBisId = undefined;
        this.districtBisName = undefined;
        this.postcode = undefined;
        this.postcodeBis = undefined;
        this.region = undefined;
        this.street2 = undefined;
        this.street3 = undefined;
        this.streetNumber = undefined;
        this.additionalNumber = undefined;
        this.neighborhood = undefined;
    }
};
__decorate([
    JsonProperty("country_id", String, false),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "countryId", undefined);
__decorate([
    JsonProperty("street1", String, false),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "street1", undefined);
__decorate([
    JsonProperty("address_verification", Number, true),
    __metadata("design:type", Number)
], AddressAccountCreation.prototype, "addressVerification", undefined);
__decorate([
    JsonProperty("city", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "city", undefined);
__decorate([
    JsonProperty("city_bis_id", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "cityBisId", undefined);
__decorate([
    JsonProperty("company", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "company", undefined);
__decorate([
    JsonProperty("district", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "district", undefined);
__decorate([
    JsonProperty("district_bis_id", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "districtBisId", undefined);
__decorate([
    JsonProperty("district_bis_name", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "districtBisName", undefined);
__decorate([
    JsonProperty("postcode", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "postcode", undefined);
__decorate([
    JsonProperty("postcode_bis", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "postcodeBis", undefined);
__decorate([
    JsonProperty("region", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "region", undefined);
__decorate([
    JsonProperty("street2", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "street2", undefined);
__decorate([
    JsonProperty("street3", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "street3", undefined);
__decorate([
    JsonProperty("street_number", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "streetNumber", undefined);
__decorate([
    JsonProperty("additional_number", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "additionalNumber", undefined);
__decorate([
    JsonProperty("neighborhood", String, true),
    __metadata("design:type", String)
], AddressAccountCreation.prototype, "neighborhood", undefined);
AddressAccountCreation = __decorate([
    JsonObject("AddressAccountCreation")
], AddressAccountCreation);

let OptinCommunication = class OptinCommunication {
};
__decorate([
    JsonProperty("email", Boolean),
    __metadata("design:type", Boolean)
], OptinCommunication.prototype, "email", undefined);
__decorate([
    JsonProperty("mail", Boolean),
    __metadata("design:type", Boolean)
], OptinCommunication.prototype, "mail", undefined);
__decorate([
    JsonProperty("phone", Boolean),
    __metadata("design:type", Boolean)
], OptinCommunication.prototype, "phone", undefined);
__decorate([
    JsonProperty("sms", Boolean),
    __metadata("design:type", Boolean)
], OptinCommunication.prototype, "sms", undefined);
OptinCommunication = __decorate([
    JsonObject("OptinCommunication")
], OptinCommunication);

/**
 * Class Customer used for account creation
 */
let Customer = class Customer extends ModelObject {
    constructor() {
        super(...arguments);
        this.address = undefined;
        this.firstname = undefined;
        this.lastname = undefined;
        this.locale = undefined;
        this.prefix = undefined;
        this.communicationConsent = undefined;
        this.country = undefined;
        this.dob = undefined;
        this.email = undefined;
        this.firstname2 = undefined;
        this.gender = undefined;
        this.lastname2 = undefined;
        this.lightAccount = undefined;
        this.loginphone = undefined;
        this.middlename = undefined;
        this.newsletterSubscription = undefined;
        this.optInCommunication = undefined;
        this.password = undefined;
        this.phonecode = undefined;
        this.piplOptin = undefined;
        this.socialSecurityNumber = undefined;
        this.telephone = undefined;
        this.verificationCode = undefined;
    }
};
__decorate([
    JsonProperty("address", AddressAccountCreation, false),
    __metadata("design:type", AddressAccountCreation)
], Customer.prototype, "address", undefined);
__decorate([
    JsonProperty("firstname", String, false),
    __metadata("design:type", String)
], Customer.prototype, "firstname", undefined);
__decorate([
    JsonProperty("lastname", String, false),
    __metadata("design:type", String)
], Customer.prototype, "lastname", undefined);
__decorate([
    JsonProperty("locale", String, false),
    __metadata("design:type", String)
], Customer.prototype, "locale", undefined);
__decorate([
    JsonProperty("prefix", String, false),
    __metadata("design:type", String)
], Customer.prototype, "prefix", undefined);
__decorate([
    JsonProperty("communicationConsent", Boolean, true),
    __metadata("design:type", Boolean)
], Customer.prototype, "communicationConsent", undefined);
__decorate([
    JsonProperty("country", String, true),
    __metadata("design:type", String)
], Customer.prototype, "country", undefined);
__decorate([
    JsonProperty("dob", DateOfBirth, true),
    __metadata("design:type", DateOfBirth)
], Customer.prototype, "dob", undefined);
__decorate([
    JsonProperty("email", String, true),
    __metadata("design:type", String)
], Customer.prototype, "email", undefined);
__decorate([
    JsonProperty("firstname2", String, true),
    __metadata("design:type", String)
], Customer.prototype, "firstname2", undefined);
__decorate([
    JsonProperty("gender", String, true),
    __metadata("design:type", String)
], Customer.prototype, "gender", undefined);
__decorate([
    JsonProperty("lastname2", String, true),
    __metadata("design:type", String)
], Customer.prototype, "lastname2", undefined);
__decorate([
    JsonProperty("light_account", Boolean, true),
    __metadata("design:type", Boolean)
], Customer.prototype, "lightAccount", undefined);
__decorate([
    JsonProperty("loginphone", String, true),
    __metadata("design:type", String)
], Customer.prototype, "loginphone", undefined);
__decorate([
    JsonProperty("middlename", String, true),
    __metadata("design:type", String)
], Customer.prototype, "middlename", undefined);
__decorate([
    JsonProperty("newsletter_subscription", Boolean, true),
    __metadata("design:type", Boolean)
], Customer.prototype, "newsletterSubscription", undefined);
__decorate([
    JsonProperty("optInCommunication", OptinCommunication, true),
    __metadata("design:type", OptinCommunication)
], Customer.prototype, "optInCommunication", undefined);
__decorate([
    JsonProperty("password", String, true),
    __metadata("design:type", String)
], Customer.prototype, "password", undefined);
__decorate([
    JsonProperty("phonecode", String, true),
    __metadata("design:type", String)
], Customer.prototype, "phonecode", undefined);
__decorate([
    JsonProperty("pipl_optin", Boolean, true),
    __metadata("design:type", Boolean)
], Customer.prototype, "piplOptin", undefined);
__decorate([
    JsonProperty("social_security_number", String, true),
    __metadata("design:type", String)
], Customer.prototype, "socialSecurityNumber", undefined);
__decorate([
    JsonProperty("telephone", String, true),
    __metadata("design:type", String)
], Customer.prototype, "telephone", undefined);
__decorate([
    JsonProperty("verification_code", String, true),
    __metadata("design:type", String)
], Customer.prototype, "verificationCode", undefined);
Customer = __decorate([
    JsonObject("Customer")
], Customer);

let CustomerCreateRequest = class CustomerCreateRequest extends Customer {
};
CustomerCreateRequest = __decorate([
    JsonObject("CustomerCreateRequest")
], CustomerCreateRequest);

let LoginV2Request = class LoginV2Request {
    constructor() {
        this.password = undefined;
        this.email = undefined;
        this.socialSecurityNumber = undefined;
        this.source = undefined;
    }
};
__decorate([
    JsonProperty("password", String),
    __metadata("design:type", String)
], LoginV2Request.prototype, "password", undefined);
__decorate([
    JsonProperty("email", String, false),
    __metadata("design:type", String)
], LoginV2Request.prototype, "email", undefined);
__decorate([
    JsonProperty("socialSecurityNumber", String, true),
    __metadata("design:type", String)
], LoginV2Request.prototype, "socialSecurityNumber", undefined);
__decorate([
    JsonProperty("source", String, true),
    __metadata("design:type", String)
], LoginV2Request.prototype, "source", undefined);
LoginV2Request = __decorate([
    JsonObject("LoginV2Request")
], LoginV2Request);

let LoginV2Response = class LoginV2Response {
    constructor() {
        this.firstname = undefined;
        this.lastname = undefined;
        this.prefix = undefined;
        this.totalItems = undefined;
    }
};
__decorate([
    JsonProperty("firstname", String),
    __metadata("design:type", String)
], LoginV2Response.prototype, "firstname", undefined);
__decorate([
    JsonProperty("lastname", String),
    __metadata("design:type", String)
], LoginV2Response.prototype, "lastname", undefined);
__decorate([
    JsonProperty("prefix", String),
    __metadata("design:type", String)
], LoginV2Response.prototype, "prefix", undefined);
__decorate([
    JsonProperty("totalItems", Number),
    __metadata("design:type", Number)
], LoginV2Response.prototype, "totalItems", undefined);
LoginV2Response = __decorate([
    JsonObject("LoginV2Response")
], LoginV2Response);

/**
 * This class define login without password config
 */
let LoginWithoutPasswordConfig = class LoginWithoutPasswordConfig {
    constructor() {
        this.enabled = false;
    }
};
__decorate([
    JsonProperty("enabled", Boolean, false),
    __metadata("design:type", Boolean)
], LoginWithoutPasswordConfig.prototype, "enabled", undefined);
LoginWithoutPasswordConfig = __decorate([
    JsonObject("LoginWithoutPasswordConfig")
], LoginWithoutPasswordConfig);

let PiplOptinRequest = class PiplOptinRequest extends ModelObject {
    constructor() {
        super(...arguments);
        this.loginAuthentication = undefined;
    }
};
__decorate([
    JsonProperty("login_authentication", String, false),
    __metadata("design:type", String)
], PiplOptinRequest.prototype, "loginAuthentication", undefined);
PiplOptinRequest = __decorate([
    JsonObject("PiplOptinRequest")
], PiplOptinRequest);

let PiplOptinResponse = class PiplOptinResponse extends ModelObject {
    constructor() {
        super(...arguments);
        this.piplOptin = undefined;
    }
};
__decorate([
    JsonProperty("pipl_optin", Boolean, false),
    __metadata("design:type", Boolean)
], PiplOptinResponse.prototype, "piplOptin", undefined);
PiplOptinResponse = __decorate([
    JsonObject("PiplOptinResponse")
], PiplOptinResponse);

/**
 * This class contains contact informations
 */
let PrivateContact = class PrivateContact extends ModelObject {
    constructor() {
        super(...arguments);
        this.email = undefined;
        this.phoneNumber = undefined;
        this.phoneCode = undefined;
        this.socialSecurityNumber = undefined;
        this.validationCode = undefined;
    }
};
__decorate([
    JsonProperty("email", String, true),
    __metadata("design:type", String)
], PrivateContact.prototype, "email", undefined);
__decorate([
    JsonProperty("phoneNumber", String, true),
    __metadata("design:type", String)
], PrivateContact.prototype, "phoneNumber", undefined);
__decorate([
    JsonProperty("phoneCode", String, true),
    __metadata("design:type", String)
], PrivateContact.prototype, "phoneCode", undefined);
__decorate([
    JsonProperty("socialSecurityNumber", String, true),
    __metadata("design:type", String)
], PrivateContact.prototype, "socialSecurityNumber", undefined);
__decorate([
    JsonProperty("validationCode", String, true),
    __metadata("design:type", String)
], PrivateContact.prototype, "validationCode", undefined);
PrivateContact = __decorate([
    JsonObject("PrivateContact")
], PrivateContact);

let ValidationCodeSendRequestBody = class ValidationCodeSendRequestBody {
    constructor() {
        this.phoneCode = undefined;
        this.phoneNumber = undefined;
    }
};
__decorate([
    JsonProperty("phoneCode", String, false),
    __metadata("design:type", String)
], ValidationCodeSendRequestBody.prototype, "phoneCode", undefined);
__decorate([
    JsonProperty("phoneNumber", String, false),
    __metadata("design:type", String)
], ValidationCodeSendRequestBody.prototype, "phoneNumber", undefined);
ValidationCodeSendRequestBody = __decorate([
    JsonObject("ValidationCodeSendRequestBody")
], ValidationCodeSendRequestBody);

let ValidationCodeCheckRequestBody = class ValidationCodeCheckRequestBody {
    constructor() {
        this.phoneCode = undefined;
        this.phoneNumber = undefined;
        this.validationCode = undefined;
    }
};
__decorate([
    JsonProperty("phoneCode", String, false),
    __metadata("design:type", String)
], ValidationCodeCheckRequestBody.prototype, "phoneCode", undefined);
__decorate([
    JsonProperty("phoneNumber", String, false),
    __metadata("design:type", String)
], ValidationCodeCheckRequestBody.prototype, "phoneNumber", undefined);
__decorate([
    JsonProperty("validationCode", String, false),
    __metadata("design:type", String)
], ValidationCodeCheckRequestBody.prototype, "validationCode", undefined);
ValidationCodeCheckRequestBody = __decorate([
    JsonObject("ValidationCodeCheckRequestBody")
], ValidationCodeCheckRequestBody);

let CustomerSessionResponse = class CustomerSessionResponse {
    constructor() {
        this.basket = undefined;
        this.lifetime = undefined;
        this.user = undefined;
    }
};
__decorate([
    JsonProperty("basket", Basket, false),
    __metadata("design:type", Basket)
], CustomerSessionResponse.prototype, "basket", undefined);
__decorate([
    JsonProperty("lifetime", String, false),
    __metadata("design:type", String)
], CustomerSessionResponse.prototype, "lifetime", undefined);
__decorate([
    JsonProperty("user", User, true),
    __metadata("design:type", User)
], CustomerSessionResponse.prototype, "user", undefined);
CustomerSessionResponse = __decorate([
    JsonObject("CustomerSessionResponse")
], CustomerSessionResponse);

let CustomerInformation = class CustomerInformation {
    constructor() {
        this.customerId = undefined;
        this.firstname = undefined;
        this.lastname = undefined;
        this.prefix = undefined;
        this.communicationConsent = undefined;
        this.email = undefined;
        this.firstname2 = undefined;
        this.gender = undefined;
        this.isBindedWechat = undefined;
        this.lastname2 = undefined;
        this.newsletter = undefined;
        this.newsletterSubscription = undefined;
        this.optInCommunication = undefined;
        this.phoneCode = undefined;
        this.phoneNumber = undefined;
        this.socialSecurityNumber = undefined;
        this.telephone = undefined;
    }
};
__decorate([
    JsonProperty("customerId", String),
    __metadata("design:type", String)
], CustomerInformation.prototype, "customerId", undefined);
__decorate([
    JsonProperty("firstname", String),
    __metadata("design:type", String)
], CustomerInformation.prototype, "firstname", undefined);
__decorate([
    JsonProperty("lastname", String),
    __metadata("design:type", String)
], CustomerInformation.prototype, "lastname", undefined);
__decorate([
    JsonProperty("prefix", String),
    __metadata("design:type", String)
], CustomerInformation.prototype, "prefix", undefined);
__decorate([
    JsonProperty("dateOfBirth", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "dateOfBirth", undefined);
__decorate([
    JsonProperty("communicationConsent", Boolean, true),
    __metadata("design:type", Boolean)
], CustomerInformation.prototype, "communicationConsent", undefined);
__decorate([
    JsonProperty("email", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "email", undefined);
__decorate([
    JsonProperty("firstname2", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "firstname2", undefined);
__decorate([
    JsonProperty("gender", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "gender", undefined);
__decorate([
    JsonProperty("isBindedWechat", Boolean, true),
    __metadata("design:type", Boolean)
], CustomerInformation.prototype, "isBindedWechat", undefined);
__decorate([
    JsonProperty("lastname2", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "lastname2", undefined);
__decorate([
    JsonProperty("newsletter", Boolean, true),
    __metadata("design:type", Boolean)
], CustomerInformation.prototype, "newsletter", undefined);
__decorate([
    JsonProperty("newsletterSubscription", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "newsletterSubscription", undefined);
__decorate([
    JsonProperty("optInCommunication", OptinCommunication, true),
    __metadata("design:type", OptinCommunication)
], CustomerInformation.prototype, "optInCommunication", undefined);
__decorate([
    JsonProperty("phoneCode", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "phoneCode", undefined);
__decorate([
    JsonProperty("phoneNumber", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "phoneNumber", undefined);
__decorate([
    JsonProperty("socialSecurityNumber", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "socialSecurityNumber", undefined);
__decorate([
    JsonProperty("telephone", String, true),
    __metadata("design:type", String)
], CustomerInformation.prototype, "telephone", undefined);
CustomerInformation = __decorate([
    JsonObject("CustomerInformation")
], CustomerInformation);

let PasswordChangeRequest = class PasswordChangeRequest {
    constructor() {
        this.oldPassword = undefined;
        this.password = undefined;
    }
};
__decorate([
    JsonProperty("oldPassword", String, false),
    __metadata("design:type", String)
], PasswordChangeRequest.prototype, "oldPassword", undefined);
__decorate([
    JsonProperty("password", String, false),
    __metadata("design:type", String)
], PasswordChangeRequest.prototype, "password", undefined);
PasswordChangeRequest = __decorate([
    JsonObject("PasswordChangeRequest")
], PasswordChangeRequest);

let ResetPasswordRequest = class ResetPasswordRequest {
    constructor() {
        this.hash = undefined;
        this.password = undefined;
        this.country = undefined;
        this.quote_id = undefined;
    }
};
__decorate([
    JsonProperty("hash", String),
    __metadata("design:type", String)
], ResetPasswordRequest.prototype, "hash", undefined);
__decorate([
    JsonProperty("password", String),
    __metadata("design:type", String)
], ResetPasswordRequest.prototype, "password", undefined);
__decorate([
    JsonProperty("country", String, true),
    __metadata("design:type", String)
], ResetPasswordRequest.prototype, "country", undefined);
__decorate([
    JsonProperty("quote_id", Number, true),
    __metadata("design:type", Number)
], ResetPasswordRequest.prototype, "quote_id", undefined);
ResetPasswordRequest = __decorate([
    JsonObject("ResetPasswordRequest")
], ResetPasswordRequest);

export { ADDRESS_SOURCE_TYPE_ENUM, AddAddressResponse, AddressAccountCreation, AddressRequest, Customer, CustomerAddressRequest, CustomerAddressResponse, CustomerCreateRequest, CustomerEditAddressResponse, CustomerInformation, CustomerSessionResponse, DateOfBirth, ForgotPasswordRequest, ForgotPasswordResponse, Guest, LoginV2Request, LoginV2Response, LoginWithoutPasswordConfig, NewsletterSubscribeRequest, OptinCommunication, PasswordChangeRequest, PiplOptinRequest, PiplOptinResponse, PrivateContact, ResetPasswordRequest, RetrieveAddressesResponse, User, ValidationCodeCheckRequestBody, ValidationCodeSendRequestBody };
